<template>
  <transition name="fade" v-on:enter="enter">
    <div v-if="localShow" :class="type" >
      <span v-html="message"></span>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'AppMessages',
    props: [
      'type',
      'message',
      'show',
    ],
    data() {
      return {
        localShow: false,
      };
    },
    watch: {
      show(value) {
        this.localShow = value;
      },
    },
    methods: {
      enter(el, done) {
        const $scope = this;

        setTimeout(() => {
          $scope.localShow = false;
        }, 3000); // hide the message after 3 seconds
      },
    },
  };
</script>
